import React from "react";
import { BrowserRouter as Router, Switch, Route, Link, HashRouter } from "react-router-dom";
import Assessment from "../screens/assessment";
import AssessmentSection from "../screens/assessmentSection";
import Main from "../screens/main";
import Organization from "../screens/organization";
import Organizations from "../screens/organizations";
import Question from "../screens/question";

function Routes() {
  return (
    <HashRouter>
      <div>
        {/*
            A <Switch> looks through all its children <Route>
            elements and renders the first one whose path
            matches the current URL. Use a <Switch> any time
            you have multiple routes, but you want only one
            of them to render at a time
          */}
        <Switch>
          <Route exact path="/">
            {/* <Organization id={1}></Organization> */}
            {/* <Main></Main> */}
            <Organizations />
          </Route>
          <Route path="/organization/:organizationId/assessment/:assessmentId">
            <Main />
          </Route>
          <Route path="/organization/:organizationId">
            <Organization />
          </Route>
          <Route path="/assessment/:assessmentId/assessmentSection/:assessmentSectionId">
            <AssessmentSection />
          </Route>
          <Route path="/assessmentSection/:assessmentSectionId/question/:questionId">
            <Question />
          </Route>
        </Switch>
      </div>
    </HashRouter>
  );
}

export default Routes;
